import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { s } from './common.js';
export function CompletedComponent(props) {
    const title = s(props.config, 'title', "You're in! 🎉");
    const body = s(props.config, 'body', 'Check your email — we sent a link to set your password and finish setting up your portal.');
    const cta = s(props.config, 'cta', 'Continue to your portal');
    const redirectKey = s(props.config, 'redirectKey', '__completed_redirect_url');
    const redirectUrl = typeof props.payload[redirectKey] === 'string'
        ? props.payload[redirectKey]
        : '';
    return (_jsxs("div", { className: "flex flex-col gap-4 text-center", children: [_jsx("h3", { className: "m-0 text-2xl font-semibold", children: title }), _jsx("p", { className: "m-0 text-sm text-[var(--bcbb-text-muted)]", children: body }), redirectUrl && (_jsx("button", { type: "button", onClick: () => (window.location.href = redirectUrl), className: "self-center rounded-md px-5 py-3 text-base font-semibold text-white", style: { background: 'var(--bcbb-primary)' }, children: cta }))] }));
}
export const CompletedArchetype = {
    name: 'Completed',
    label: 'Completed',
    description: 'Post-signup landing card with redirect-to-portal button.',
    component: CompletedComponent,
    isFormArchetype: false,
    fields: {
        title: { kind: 'text', label: 'Title' },
        body: { kind: 'textarea', label: 'Body' },
        cta: { kind: 'text', label: 'CTA label' },
        redirectKey: { kind: 'text', label: 'Redirect URL payload key' },
    },
    defaultConfig: {
        title: "You're in! 🎉",
        body: 'Check your email — we sent a link to set your password and finish setting up your portal.',
        cta: 'Continue to your portal',
        redirectKey: '__completed_redirect_url',
    },
};
